import React from "react";

const SvgHeart = (props) => (
  <svg width="16" viewBox="0 0 16 14" {...props}>
    <defs>
      <path
        id="heart_svg"
        d="M708.99 1629.896c-.163 3.61-2.537 5.438-5.338 8.044a3.868 3.868 0 0 1-2.644 1.054 3.886 3.886 0 0 1-2.641-1.046c-2.832-2.61-5.238-4.45-5.36-8.163-.154-4.664 4.849-6.553 7.682-2.762a.38.38 0 0 0 .306.154.39.39 0 0 0 .314-.159c2.826-3.807 7.897-1.891 7.681 2.878zm-1.597-.08c.143-3.174-2.993-4.225-4.825-1.758a1.95 1.95 0 0 1-1.573.806 1.94 1.94 0 0 1-1.562-.796c-1.873-2.506-4.928-1.392-4.828 1.659.095 2.882 1.925 4.287 4.799 6.936.456.42 1.02.644 1.604.644.584 0 1.148-.224 1.586-.632 2.772-2.58 4.671-4.036 4.799-6.86z"
      />
    </defs>
    <use
      fill={props.color || "currentColor"}
      xlinkHref="#heart_svg"
      transform="translate(-693 -1625)"
    />
  </svg>
);

export default SvgHeart;
